/**
 * How many nav labels fit on the bar.
 *
 * Duplicated from the candidate app rather than imported: `admin/` and `app/`
 * are separate TypeScript projects whose libs exclude each other, the same
 * reason the payment gateway interface is declared twice. The arithmetic is
 * identical on purpose, so the two headers behave the same way.
 *
 * Nothing here is a typed breakpoint. A number chosen for the labels and the
 * viewport somebody had in front of them goes wrong silently the moment a
 * label is renamed or a screen is added.
 */

export const NAV_GAP = 4;

export function howManyFit(
  widths: readonly number[],
  available: number,
  triggerWidth: number,
  gap: number = NAV_GAP,
): number {
  if (widths.length === 0) return 0;

  // No trigger is drawn when the whole set fits, so it costs nothing here.
  const whole = widths.reduce((sum, one) => sum + one, 0) + gap * (widths.length - 1);
  if (whole <= available) return widths.length;

  const room = available - triggerWidth - gap;
  let used = 0;
  let count = 0;
  for (const width of widths) {
    const next = used + width + (count === 0 ? 0 : gap);
    if (next > room) break;
    used = next;
    count += 1;
  }
  return count;
}
